module.exports = __webpack_public_path__ + "img/Modernisme_Episke_forfattere4.15d7f715.jpg";